import { Component } from '@angular/core';
import {AlertController, App, Events, IonicPage, ModalController, NavController, NavParams} from 'ionic-angular';
import {AppVideoDetailsPage} from "../app-video-details/app-video-details";
import {AppDashboardPage} from "../app-dashboard/app-dashboard";
import {CourseModule} from "../../models/course-module";
import {CourseQuizQuestion, CourseVideo} from "../../models/course-video";
import {AppStepUpdatePage} from "../app-step-update/app-step-update";
import {UserStateProvider} from "../../providers/user-state/user-state";
import {ContentTranslationProvider} from "../../providers/content-translation/content-translation";
import {AppVideoPlayerPage} from "../app-video-player/app-video-player";
import {AppPaymentPage} from "../app-payment/app-payment";
import {ApiCourseDataProvider} from "../../providers/api-course-data/api-course-data";
import {AppVideoQuizPage} from "../app-video-quiz/app-video-quiz";
import {AppMyWayPage} from "../app-my-way/app-my-way";
import {AppVideoMyWayPage} from "../app-video-my-way/app-video-my-way";
import {AppVideoTipsPage} from "../app-video-tips/app-video-tips";
import {AppRegistrationStartPage} from "../app-registration-start/app-registration-start";
import {ApiProvider} from "../../providers/api/api";
import {UserProgressStateProvider} from "../../providers/user-progress-state/user-progress-state";

/**
 * Generated class for the AppModuleDetailsPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-app-module-details',
  templateUrl: 'app-module-details.html',
})
export class AppModuleDetailsPage {

  progress: number = 0;
  moduleVideoDetailsPage: any = AppVideoPlayerPage;
  videoTipsPage: any = AppVideoTipsPage;

  module: CourseModule;

  finishedVideos: CourseVideo[];
  activeVideo: CourseVideo;
  futureVideos: CourseVideo[];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private app: App,
    public userState: UserStateProvider,
    public alertCtrl: AlertController,
    public contentTranslation: ContentTranslationProvider,
    public events: Events,
    public courseDataProvider: ApiCourseDataProvider,
    public api: ApiProvider,
    public userProgress: UserProgressStateProvider
  ) {
    if(!this.navParams.data) {
      this.navCtrl.push(AppDashboardPage)
    }
    this.module = (this.navParams.data as CourseModule);

    this.finishedVideos = [];
    this.futureVideos = [];

    var me = this;
    var loadData = () => {
      this.finishedVideos = [];
      this.futureVideos = [];
      this.activeVideo = null;
      this.module.videos.map((video: CourseVideo) => {
        if(video._userStatus == 3 || this.module.type == 'greeting') {
          me.finishedVideos.push(video);
          return;
        }
        if(video._userStatus == 1) {
          me.futureVideos.push(video);
        }
        if(video._userStatus == 2) {
          me.activeVideo = video;
        }
      });
    };
    loadData();

    let stateRefreshHandler = () => {
      var moduleId = this.module.id;
      this.courseDataProvider.getCourseData().then(data => {
        for(var k in data) {
          if(data[k].id == moduleId) {
            console.log(data[k]);
            this.module = data[k];
            loadData();
          }
        }
      })
    }

    this.events.subscribe('state:refreshed', stateRefreshHandler);
    this.events.subscribe('state:refreshed-locally', stateRefreshHandler);

  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AppModuleDetailsPage');
    this.events.publish('app:module-details-opened', {moduleId: this.module.id});

    if(this.module.position == 2 && !this.userState.getAdditionalParam('reviewRequested')) {
      this.userState.setAdditionalParam('reviewRequested', 1);

      if((window as any).AppRate) {
        let AppRate = (window as any).AppRate;
        AppRate.setPreferences({
          displayAppName: 'VIDEA Mellitus',
          reviewType: {
            ios: 'InAppReview',
            android: 'InAppReview'
          },
          storeAppURL: {
            ios: '1429708933',
            android: 'market://details?id=de.tumaini.videa.mellitus',
          },
          useLanguage: 'de',
          openUrl: function(url) {
            window.open(url, '_blank', 'location=yes');
          }

        })
        AppRate.promptForRating()
        this.api.callPut('/users/'+this.userState.user.id, {additionalData: this.userState.user.additionalData}).subscribe((res:any) => {})
      }
    }
  }

  showQuizTips(module: CourseModule, e) {
    this.app.getRootNav().push(this.videoTipsPage, {module: module})
    e.preventDefault();
    e.stopPropagation();
  }

  showPracticeTips(module: CourseModule, e) {
    this.app.getRootNav().push(this.videoTipsPage, {module: module, template: 'practice'})
    e.preventDefault();
    e.stopPropagation();
  }

  openVideo(video: CourseVideo) {
    if(video._userStatus == 2 && this.userState.user.locked) {
      if(this.userState.user.insurance && this.userState.user.insurance.type) {
        this.app.getRootNav().push(AppPaymentPage, null, {animate: false})
      } else {
        this.app.getRootNav().push(AppRegistrationStartPage, null, {animate: false})
      }
    } else {
      this.navCtrl.push(AppVideoPlayerPage, video);
    }
  }

  openNotAvailableInfo() {
    const alert = this.alertCtrl.create({
      title: this.contentTranslation.translateContent('Wann werden Kurstage freigeschaltet?'),
      subTitle: this.contentTranslation.translateContent('Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. \n'),
      buttons: [
        {
          text: 'OK',
        },
        {
          text: '×',
          cssClass: 'close-button'
        }

      ],
      cssClass: 'ip-alert ip-with-close'
    });
    alert.present();

  }

  openQuiz(video: CourseVideo, videoWatched: boolean = true) {
    if(videoWatched) {
      this.app.getRootNav().push(AppVideoQuizPage, video);
    } else {
      this.openVideo(video);
    }

  }
  openMyWay(video: CourseVideo) {
    this.app.getRootNav().push(AppVideoMyWayPage, video);
  }
}



// WEBPACK FOOTER //
// ./src/pages/app-module-details/app-module-details.ts